/* global angular, $ */
angular.module('ua5App')
    .directive('scrollProgressHorizontalBar', [function() {
        return {
            restrict: 'A',
            scope: {
                verticaloffset: '@'
            },
            link: function($scope, element, attrs) {

                var barBaseWidth = 50;
                var verticalOffset = parseInt($scope.verticaloffset, 10);
                var bar = $(element);
                var scrollableHeight;
                var scrollableBarWidth;
                var docHeight;

                function calculateDimensions() {
                    docHeight = $(document).height();
                    scrollableHeight = docHeight - $(window).height();
                    scrollableBarWidth = $(element).parent().width() - barBaseWidth;
                }

                function setScrollingBarWidth() {
                    var currentScroll = $(window).scrollTop();
                    var windowOffset = verticalOffset - currentScroll;
                    var currentBarPercent;
                    var barWidth;

                    if (docHeight !== $(document).height()) {
                        calculateDimensions();
                    }

                    currentBarPercent = (currentScroll - verticalOffset) / (scrollableHeight - verticalOffset);
                    barWidth = (currentBarPercent * scrollableBarWidth) + barBaseWidth + 'px';

                    if (windowOffset < 1) {
                        bar.width(barWidth);
                    } else {
                        bar.width(barBaseWidth);
                    }
                }

                calculateDimensions();
                $(window).scroll(setScrollingBarWidth);
                $scope.$on('resourceComponentPosition', calculateDimensions);
                $scope.$on('app:resized', calculateDimensions);
            }
        };
    }])
    .directive('scrollProgressVerticalBar', [function() {
        return {
            restrict: 'A',
            scope: {
                verticaloffset: '@'
            },
            link: function($scope, element, attrs) {

                var barBaseHeight = 20;
                var bar = $(element);
                var verticalOffset = parseInt($scope.verticaloffset, 10);
                var scrollableHeight ;
                var scrollableBarHeight;
                var docHeight;

                function calculateDimensions() {
                    scrollableHeight = $(document).height() - $(window).height();
                    scrollableBarHeight = $(window).height() - barBaseHeight;
                }

                function setScrollingBarHeight() {

                    var currentScroll = $(window).scrollTop();
                    var windowOffset = verticalOffset - currentScroll;

                    var currentBarPercent;
                    var barHeight;

                    if (docHeight !== $(document).height()) {
                        calculateDimensions();
                    }

                    currentBarPercent = (currentScroll - verticalOffset) / (scrollableHeight - verticalOffset);
                    barHeight = (currentBarPercent * scrollableBarHeight) + barBaseHeight + 'px';

                    if (windowOffset < 1) {
                        bar.height(barHeight);
                    } else {
                        bar.height(barBaseHeight);
                    }
                }

                calculateDimensions();
                $(window).scroll(setScrollingBarHeight);
                $scope.$on('resourceComponentPosition', calculateDimensions);
                $scope.$on('app:resized', calculateDimensions);
            }
        };
    }])
;
